'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UIModal = require('UIComponents/dialog/UIModal');

var _UIModal2 = _interopRequireDefault(_UIModal);

var _UIDialogBody = require('UIComponents/dialog/UIDialogBody');

var _UIDialogBody2 = _interopRequireDefault(_UIDialogBody);

var _UIErrorMessage = require('UIComponents/error/UIErrorMessage');

var _UIErrorMessage2 = _interopRequireDefault(_UIErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LANG_ROUTE = 'upgrades.activationModal';

var ActivationErrorModal = function ActivationErrorModal() {
  return _react2.default.createElement(
    _UIModal2.default,
    { size: 'auto', use: 'conversational', width: 500 },
    _react2.default.createElement(
      _UIDialogBody2.default,
      null,
      _react2.default.createElement(
        _UIErrorMessage2.default,
        null,
        _react2.default.createElement(
          'p',
          { className: 'm-bottom-0' },
          _react2.default.createElement(_FormattedMessage2.default, { message: LANG_ROUTE + '.errorTitle' })
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(_FormattedMessage2.default, { message: LANG_ROUTE + '.errorMessage' })
        )
      )
    )
  );
};

exports.default = ActivationErrorModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/components/ActivationErrorModal.js
// module id = 364
// module chunks = 3 4 5